import React from "react";
import { string } from "prop-types";

const TagsIcon = ({ color = "#8F0F01" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16.335 16.335">
      <path
        fill="#c00000"
        d="M0 8.044V1.531A1.531 1.531 0 0 1 1.531 0h6.513a1.531 1.531 0 0 1 1.083.449l6.76 6.76a1.531 1.531 0 0 1 0 2.166l-6.513 6.512a1.531 1.531 0 0 1-2.166 0L.449 9.127A1.531 1.531 0 0 1 0 8.044zm3.573-6A1.531 1.531 0 1 0 5.1 3.573a1.531 1.531 0 0 0-1.527-1.531z"
      />
    </svg>
  );
};

TagsIcon.propTypes = {
  color: string,
};

export default TagsIcon;
